import { selectBillingMethodById } from '@store/business/BillingMethodReducer'
import { useAppSelector } from '@store/hooks'

interface Props {
  id: number
}

export const BillingMethodAvatar = ({ id }: Props) => {
  const billingMethod = useAppSelector(selectBillingMethodById(id))
  return billingMethod ? billingMethod.name : ''
}

export type BillingMethodAvatarType = {
  Avatar: typeof BillingMethodAvatar
}
